<template lang="pug">
  v-card(v-if="currentAnimalType")
    v-card-title
     h2.card-title {{ $t('base.edit_animal_type') }}
    v-card-content
      v-text-field(
        :focus="true"
        :label="$t('base.type_animal_type_name')"
        v-model="currentAnimalType.name")
    v-card-actions
      v-btn.mr-2(
        @click="onUpdate"
        :loading="loading") {{ $t('base.save') }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsTypeModal',

  components: {
    DeleteBtn
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'currentAnimalType'
    ])
  },

  methods: {
    ...mapActions('animaltypes', [
      'updateAnimalType',
      'deleteAnimalType'
    ]),

    async onUpdate () {
      this.loading = true

      const error = await this.updateAnimalType()

      this.loading = false

      if (!error) {
        this.$emit('update')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    },

    async onDelete () {
      await this.deleteAnimalType()
      this.$emit('remove')
    }
  }
}
</script>